import {
  GenericCreateResponse,
  GenericDeleteResponse,
  GenericUpdateResponse,
  GraphQLHelper,
} from "../../api/types";

export const CustomerMutations = GraphQLHelper("customer");

export type CreateCustomerResponse = GenericCreateResponse<"customer">;
export type UpdateCustomerResponse = GenericUpdateResponse<"customer">;
export type DeleteCustomerResponse = GenericDeleteResponse<"customer">;
